import type { TOC } from '@ember/component/template-only'
import { eq } from 'ember-truth-helpers'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface Signature {
  Args: {
    Named: {
      subscriptionType: SubscriptionType
    }
  }
}

export const LoginCardFooter: TOC<Signature> = <template>
  <span data-test-card-footer-url>
    {{! template-lint-disable no-bare-strings }}
    {{if (eq @subscriptionType SubscriptionType.Reading) "readingeggs.com/signin"}}
    {{if (eq @subscriptionType SubscriptionType.Maths) "mathseeds.com/signin"}}
    {{if (eq @subscriptionType SubscriptionType.Writing) "readingeggs.com/signin"}}
  </span>
</template>
